<template>
  <div class="otn-step-three">
    <v-switch
      v-model="form.idc_bracket"
      hide-details
      label="Support :"
      class="title mb-4"
      @change="clearBracketsFields"
    />
    <v-radio-group
      v-model="form.bracket"
      row
      :disabled="!form.idc_bracket"
    >
      <v-radio
        label="Nouveau"
        value="NEW"
      />
      <v-radio
        label="Existant"
        value="EXISTING"
      />
    </v-radio-group>

    <hr>

    <v-flex sm8>
      <v-radio-group
        v-model="form.bracket_type"
        row
        hide-details
        :disabled="!form.idc_bracket"
      >
        <v-layout
          class="checkbox-input-container mb-4"
          align-center
        >
          <v-flex>
            <v-radio
              label="VLONDER"
              value="VLONDER"
            />
          </v-flex>
        </v-layout>
        <v-layout
          class="checkbox-input-container mb-4 mr-6"
          align-center
        >
          <v-flex>
            <v-radio
              label="IKEA"
              value="IKEA"
            />
          </v-flex>
        </v-layout>
        <v-layout
          class="checkbox-input-container mb-4"
          align-center
        >
          <v-flex class="ml-6">
            <v-radio
              hide-details
              label="Autre"
              value="OTHER"
            />
          </v-flex>
        </v-layout>
      </v-radio-group>
    </v-flex>

    <v-layout>
      <v-flex row>
        <v-flex
          sm4
          mb-5
          mr-12
          ml-3
          class="checkbox-input visible"
        >
          <v-select
            v-model="form.type"
            :disabled="form.bracket_type == 'OTHER' || !form.idc_bracket"
            :items="dropdowns.type"
            item-value="value"
            item-text="label"
            label="PM :"
            filled
            clearable
            hide-details
          />
        </v-flex>

        <v-flex
          sm4
          ml-12
          class="checkbox-input visible"
        >
          <v-text-field
            v-model="form.other"
            :disabled="form.bracket_type !== 'OTHER' || !form.idc_bracket"
            hide-details
            maxlength="15"
            outlined
          />
        </v-flex>
      </v-flex>
    </v-layout>

    <v-flex sm6>
      <v-radio-group
        v-model="form.bracket_location"
        hide-details
        row
        :disabled="!form.idc_bracket"
      >
        <v-radio
          label="Atelier"
          value="WORKSHOP"
        />
        <v-radio
          label="Chez le patient"
          value="PATIENT_HOME"
        />
      </v-radio-group>
      <v-text-field
        v-model="form.serial_number"
        class="mt-4"
        label="Numéro de série"
        maxlength="15"
        hide-details
        outlined
        :disabled="!form.idc_bracket"
      />
    </v-flex>

    <v-switch
      v-model="form.idc_corner_schema"
      hide-details
      label="Schéma coin :"
      class="title mt-12"
      @change="clearCornerSchemaFields"
    />

    <v-layout
      justify-space-between
      align-end
      mb-12
    >
      <v-flex
        sm7
        mt-6
        class="left-schema"
      >
        <div class="content">
          <div class="img-container">
            <img src="@/assets/img/schema_otn_3a.svg">
            <v-text-field
              v-model="form.triangle_a"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma coin) Champ A"
              :class="{ error: errors.has('(Schéma coin) Champ A') }"
              type="number"
              style="top: 40.3%;left: 0;"
              height="100%"
              :disabled="!form.idc_corner_schema"
              outlined
            />
            <v-text-field
              v-model="form.triangle_b"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma coin) Champ B"
              :class="{ error: errors.has('(Schéma coin) Champ B') }"
              type="number"
              style="top: 72.4%;left: 42.5%;"
              height="100%"
              :disabled="!form.idc_corner_schema"
              outlined
            />
            <v-text-field
              v-model="form.triangle_c"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma coin) Champ C"
              :class="{ error: errors.has('(Schéma coin) Champ C') }"
              type="number"
              style="top: 45.3%;left: 85.5%;"
              height="100%"
              :disabled="!form.idc_corner_schema"
              outlined
            />
          </div>
        </div>
      </v-flex>

      <v-flex sm5>
        <v-radio-group
          v-model="form.embedded"
          :disabled="!form.idc_corner_schema"
        >
          <v-radio
            label="Intégré"
            value="EMBEDDED"
          />
          <v-radio
            label="Amovible"
            value="REMOVABLE"
          />
        </v-radio-group>
      </v-flex>
    </v-layout>

    <h3 class="mb-4">Réf LPPR</h3>

    <v-layout justify-space-between>

      <v-flex
        column
        sm6
      >
        <v-layout
          v-for="article in articlesList"
          :key="article.article_id"
          class="checkbox-input-container"
        >
          <v-flex>
            <v-checkbox
              v-model="getArticleFormData(article.article_id).idc_want"
              @change="onArticleCheckChange(article.article_id, $event)"
              :label="article.label"
              hide-details
            >
              <template v-slot:label>
                <h4>{{ article.article_reference }}</h4>
                <h4>{{ article.label }}</h4>
              </template>
            </v-checkbox>
          </v-flex>
          <v-flex
            v-if="article.idc_entry"
            class="checkbox-input visible"
          >
            <InputNumber
              v-model="getArticleFormData(article.article_id).value"
              class="input-number"
              :disable="!getArticleFormData(article.article_id).idc_want"
            />
          </v-flex>
        </v-layout>

        <v-layout class="checkbox-input-container">
          <v-flex>
            <v-checkbox
              v-model="form.idc_stop_dorsolumbar_hinge"
              label
              hide-details
            >
              <template v-slot:label>
                <h4 />
                <h4>S’arrêtant à la charnière dorso-lombaire</h4>
              </template>
            </v-checkbox>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex sm6>
        <v-textarea
          v-model="form.comment_sewing"
          filled
          label="Commentaires :"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { articles } from "@/mixins/articles";

import InputNumber from "@/components/InputNumber.vue";

export default {
  name: "OtnStepThree",
  inject: ["parentValidator"],
  components: {
    InputNumber
  },
  mixins: [articles],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      dropdowns: "dropdowns/getOtnOptions"
    })
  },
  async created() {
    this.$validator = this.parentValidator;

    await this.loadArticles("OTN");

    if (this.form.articles.length <= 0) {
      this.form.articles = this.articles;
    }
  },
  methods: {
    // Clear bracket fields
    clearBracketsFields() {
      this.form.bracket = null;
      this.form.bracket_type = null;
      this.form.type = null;
      this.form.other = null;
      this.form.bracket_location = null;
      this.form.serial_number = null;
    },

    // Clear corner schema fields
    clearCornerSchemaFields() {
      this.form.triangle_a = null;
      this.form.triangle_b = null;
      this.form.triangle_c = null;
      this.form.embedded = null;
    },

        /**
     * Récupère les données d'un article dans form.articles à partir de son ID
     * @param {String|Number} articleId - L'ID de l'article à récupérer
     * @returns {Object} - L'objet article correspondant dans form.articles
     */
     getArticleFormData(articleId) {
      // Chercher l'article dans form.articles
      const article = this.form.articles.find(a => a.article_id === articleId);
      
      // Si l'article n'existe pas, créer un nouvel objet avec des valeurs par défaut
      if (!article) {
        const newArticle = {
          article_id: articleId,
          idc_want: false,
          value: null
        };
        
        // Ajouter le nouvel article à form.articles
        this.form.articles.push(newArticle);
        
        return newArticle;
      }
      
      return article;
    },
    
    /**
     * Réinitialise la valeur d'un article à null lorsqu'il est décoché
     * @param {String|Number} articleId - L'ID de l'article
     * @param {Boolean} checked - État de la case à cocher
     */
    onArticleCheckChange(articleId, checked) {
      const article = this.getArticleFormData(articleId);
      if (!checked && article.value !== null) {
        article.value = null;
      }
    }
  }
};
</script>

<style lang="scss">
.otn-step-three {
  .img-container {
    position: relative;
    display: inline-block;
    margin: auto;
    img {
      height: 100%;
      width: 100%;
      // min-width: 800px;
      @media (max-width: 800px) {
        min-width: auto;
      }
    }
    .v-input {
      position: absolute;
      width: 14.6%;
      height: 23.4%;
      @media (max-width: 800px) {
        height: 23.4%;
      }
      .v-input__control {
        height: 100%;
        .v-input__slot {
          min-height: auto;
        }
      }
    }
  }
  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        top: 0;
        transform: none;
        margin-left: 15px;
        max-width: 80px !important;
        &:not(.visible) {
          display: none;
        }
      }
    }
  }
  .v-input--selection-controls {
    margin-top: 0;
    &.v-input {
      .v-input__control {
        flex-grow: 1;
      }
      .v-label {
        width: 100%;
        h4 {
          font-size: 10px !important;
          &:first-child {
            color: #333;
            margin-right: 5px;
            font-size: 12px !important;
          }
        }
      }
    }
    .v-input__slot {
      align-items: flex-start;
      overflow: hidden;
      margin-bottom: 15px;
      .v-label {
        align-items: baseline;
      }
    }
  }
  hr {
    width: 100%;
    margin: 0;
    margin-bottom: 15px;
  }
}
</style>
